<template>
    <div class="monitorDetails">
        <div class="container">
            <!--      导航      -->
            <div class="nav">
                <div class="nav_left">
                    <span class="nav_title">监测详情</span>
                    <span class="all_result">全部结果 ></span>
                    <span>{{ allResults }}个结果</span>
                </div>

                <div class="nav_right title_btn_group">
                    <a v-if="reportUrl && reportUrl!='' " :href="reportUrl" class="gray_btn">下载报告</a>
                    <span @click="goBack" style="width: 104px;margin-left: 20px;" class="gray_btn">返回监测明细</span>
                </div>
            </div>

            <div class="monitorDetails_main">
                <div class="monitorDetails_main_header">
                    <div class="monitorDetails_main_header_title">监测结果</div>
                    <div @click="batchObtainEvidence" class="monitorDetails_main_header_btn">批量取证</div>
                </div>


                <div class="monitorDetails_main_title">
                    <ul class="title_group">
                        <li
                                @click="optionSwitch"
                                :data-index="index"
                                v-for="(item,index) in monitorTotalData"
                                :key="index"
                                :class=" optionValue == index ? 'active title_item' : 'title_item'">
                            {{item.name}}（{{item.total}}）
                        </li>
                    </ul>
                </div>

                <div class="tips_text" v-if="noData && pageNum == 1">
                    <img class="tips_text_img" src="./images/monitor_nodata.png" alt='版权登记'>
                    <p class="tips_text_content">您所选的监测范围暂未监测出传播数据</p>
                </div>
                <ul v-else class="monitorDetails_group">
                    <monitorItem class="result_item"
                                 v-for="(item,index) in DetailsData"
                                 :data="item"
                                 :isChoice="true"
                                 :isChecked="obtainEvidenceData.indexOf(item.link) == -1 ? false :true"
                                 @monitorItemFather="obtainEvidenceCheck($event)"></monitorItem>
<!--                    :isChecked="obtainEvidenceData.indexOf(item.link) == -1 ? false :true"-->

                </ul>
            </div>

            <div v-if="!noData" @click="loadMore" class="gray_btn large">加载更多</div>
            <div v-else-if="pageNum!=1" style="cursor: default;" class="no_data large">没有更多数据了</div>
        </div>


        <generalframe @fatherMethod="obtainEvidenceTipsMethod" v-if="obtainEvidenceTips" mywidth="500" myheight="320"
                      myTitleheight="45" :tishihide="false" maintitle="提示">
            <div class="obtain_evidence_tips">
                <p class="obtain_evidence_tips_content">取证中，请前往个人中心查看</p>
                <div @click="goeVidenceAndTort" class="obtain_evidence_tips_btn">查看</div>
            </div>
        </generalframe>

        <generalframe myheight="450" mywidth="800" @fatherMethod="showDialog = false" v-if="showDialog"
                      :maintitle=" obtainEvidenceData && obtainEvidenceData.length >1 ? '确认进行批量取证' : '网页取证' " ref="mychild">

            <div style="margin-top: 30px;font-size: 15px;" v-if="obtainEvidenceData && obtainEvidenceData.length >1">您一共选择{{ obtainEvidenceData.length }}个侵权链接，会扣除{{ obtainEvidenceData.length }}次取证次数</div>
            <div style="display: flex; margin-top: 30px; min-height: 200px">
                <div style="width: 150px; line-height: 42px;">支付方式：</div>
                <div>
                    <component :is="PayWayCom" @onselected="payWay = $event" :batchNum="obtainEvidenceData.length" type="03"></component>
                </div>
            </div>
            <input @click="submitEvidence" :disabled="disabled" class="submit-button" type="button" value="确定"/>
        </generalframe>
    </div>
</template>

<script>
    import {_saveWebpage, _getresave} from "@/api/evidence.js";
    import {_monitorTotal, _getValidByPage} from '@/api/monitor.js';
    import monitorItem from "@/views/vipClip/monitor/components/monitorItem";
    import Cookies from "js-cookie";
    // import $ from 'jquery';
    import generalframe from '@/views/vipClip/vip/lawcomponent/generalframe';
    import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay';
    import payWay from '@/views/main-components/pay-way';

    import {router} from "../../../router";
    import {bqjUrl} from "../../../config/config"

    export default {
        metaInfo: {
            title: '监测详情|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '监测详情,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "monitorDetails",
        components: {
            monitorItem,
            generalframe,
            payWay,
            myczPay
        },
        data() {
            return {
                userInfo: '', //用户信息
                allResults: '', //全部结果
                monitorId: '', //监测id
                monitorTotalData: [], //分类列表
                DetailsData: [], //详情列表
                reportUrl: '', //监测报告url
                optionValue: 0, //当前选中分类
                pageNum: 1, //当前页数
                pageSize: 12, //当前请求数据尺寸
                loadMoreFlag: true, //是否可以点击加载更多
                noData: false, //分页无数据
                obtainEvidenceData: [], //批量取证数据
                obtainEvidenceTips: false, //取证提示弹框
                showDialog: false,
                payWay: null,
                disabled: false,
                PayWayCom: ''

            }
        },
        created() {
            // console.log(bqjUrl)
            if (Cookies.get("userInfo") && Cookies.get("userInfo") != '') {
                this.userInfo = JSON.parse(Cookies.get("userInfo"));
                if (this.$route.query.id && this.$route.query.id != '') {
                    this.monitorId = this.$route.query.id;
                    this.monitorTotal();
                }


            } else {
                this.$router.push("/login");
            }
        },
        methods: {
            /******************tab切换事件*******************/
            optionSwitch(data) {
                let newIndex = this.optionValue;
                let nowIndex = data.target.dataset.index;

                if (newIndex != nowIndex) {
                    this.optionValue = nowIndex;
                    this.DetailsData = [];
                    this.pageNum = 1;
                    this.noData = false;
                    this.getValidByPage();
                }
            },

            /******************获取分类信息*******************/
            monitorTotal() {
                let data = {contentId: this.monitorId};
                _monitorTotal(data).then(res => {
                    if (res.code == 200) {
                        this.allResults = res.result.total;
                        this.reportUrl = res.result.reportUrl;
                        if (res.result.array.length != 0) {
                            let monitorTotalData = res.result.array;
                            this.monitorTotalData = monitorTotalData;
                            this.optionValue = 0;
                            this.getValidByPage();
                        } else {
                            this.noData = true;
                        }

                    }
                }, (err) => {
                    console.log(err);
                })
            },

            /******************获取详情页信息*******************/
            getValidByPage() {
                let nowItem = this.monitorTotalData[this.optionValue];
                let data = {
                    contentId: nowItem.contentId,
                    scopeId: nowItem.scopeId,
                    platformId: nowItem.platformId,
                    pageNumber: this.pageNum,
                    pageSize: this.pageSize,
                    sort: 'create_date',
                    order: 'desc'
                };
                _getValidByPage(data).then(res => {
                    this.loadMoreFlag = false;
                    if (res.code == 200) {
                        let records = res.result.records;
                        if (records.length != 0) {
                            this.DetailsData = this.DetailsData.concat(records);
                            this.pageNum = this.pageNum - 0 + 1;
                        } else {
                            this.noData = true;
                        }
                    }

                    this.loadMoreFlag = true;
                }, (err) => {
                    this.loadMoreFlag = true;
                })

            },

            /******************加载更多*******************/
            loadMore() {
                if (this.loadMoreFlag) {
                    this.getValidByPage();
                }
            },

            /******************返回上一页*******************/
            goBack() {
                // this.$router.replace('/monitoring?id=' + this.monitorId);
                this.$router.push({name: 'monitoring', query: {id: this.monitorId, type: 1}})
            },

            /******************接收子组件，批量取证数据检查*******************/
            obtainEvidenceCheck(e) {
                let obtainEvidenceData = this.obtainEvidenceData;
                let obtainEvidenceDataIndexof = obtainEvidenceData.indexOf(e);
                if (obtainEvidenceDataIndexof == -1) {
                    if(obtainEvidenceData.length>=10){
                        toast('批量取证，一次最多可选择十个')
                    }
                    else{
                        obtainEvidenceData.push(e)
                    }
                } else {
                    obtainEvidenceData.splice(obtainEvidenceDataIndexof, 1)
                }
                this.obtainEvidenceData = obtainEvidenceData;
            },

            /******************接收模态框子组件，关闭弹框*******************/
            obtainEvidenceTipsMethod() {
                this.obtainEvidenceTips = false;
            },

            /******************批量取证按钮*******************/
            batchObtainEvidence() {
                let obtainEvidenceData = this.obtainEvidenceData;
                if (obtainEvidenceData && obtainEvidenceData.length > 0) {

                    this.showPayWay();

                } else {
                    toast('请选择监测结果后再进行取证')
                }
            },

            /******************跳转我的取证*******************/
            goeVidenceAndTort() {
                router.push('/evidenceAndTort');
            },

            /******************跳转我的取证*******************/
            showPayWay() {
                let _this = this
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                if (!userInfo || userInfo == '') {
                    _this.$store.state.app.showLoginOrRegistter = true;
                    return false;
                }
                this.showDialog = true;
                this.PayWayCom = 'payWay'

            },

            submitEvidence() {
                console.log('点击')
                this.disabled = true;
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                const data = {
                    urls:JSON.stringify(this.obtainEvidenceData),
                    registerId: userInfo && userInfo.id ? userInfo.id : '',
                };

                console.log(data)
                if ( this.payWay && this.payWay.gift.countNumber < this.obtainEvidenceData.length || !this.payWay) {
                    toast('无可用次数');
                    this.disabled = false;
                    return false;
                } else {
                    if (this.payWay.gift.activityGiftId) {
                        Object.assign(data, {activityGiftId: this.payWay.gift.activityGiftId})
                    }
                }
                _saveWebpage(data).then(res => {
                    if (res.code == 200) {
                        this.obtainEvidenceData = [];
                        this.showDialog = false;
                        this.obtainEvidenceTips = true;
                        this.disabled = false;
                    } else if (res.code == 214) {
                        toast("请购买会员后使用功能");
//                if(userInfo.accountType=="person" ){
//                  this.$router.push('/vipPersonal')
//                }else{
//                  this.$router.push('/vipEnterprise')
//                }
                        this.$router.push({path: '/huiyuan.html'})
                    } else if (res.code == 215) {
                        toast("VIP已到期，请续费");
                        this.myczPayState = true;
                        this.disabled = false;
                    } else if (res.code == 216) {
                        //toast("剩余次数不足，请购买加油包")
                        this.monitorBagState = true;
                        this.disabled = false;
                    } else if (res.code == 213) {
                        toast("请实名认证后使用功能");
                        if (userInfo.accountType == "person") {
                            this.$router.push('/authentication')
                        } else {
                            this.$router.push('/authentication')
                        }
                    } else {
                        toast(res.message);
                        this.disabled = false;
                    }
                });

            },
        }
    }
</script>

<style scoped lang="less">
    ul, ol {
        list-style: none;
    }

    .container {
        width: 1334px;
        margin: 0 auto;
    }

    .monitorDetails {
        min-height: 600px;
    }

    .monitorDetails .nav {
        padding: 20px 0;
        color: #333333;
        font-size: 14px;
        display: flex;
        line-height: 20px;
        justify-content: space-between;
        align-items: center;
    }

    .nav .nav_title {
        font-size: 16px;
    }

    .nav .all_result {
        padding-left: 15px;
        padding-right: 6px;
    }

    .monitorDetails_main {
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
        border-radius: 2px;
    }

    .monitorDetails_main .monitorDetails_main_header {
        background: #fff;
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
        border-radius: 2px 2px 0 0;
        padding: 10px 30px 10px 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 63px;
        box-sizing: border-box;
    }

    .monitorDetails_main .monitorDetails_main_title {
        display: flex;
        justify-content: space-between;
        padding: 20px 30px 10px 20px;
        width: 100%;
        box-sizing: border-box;
        margin-right: -20px;
    }

    .monitorDetails_main .monitorDetails_main_header_btn {
        background: #FFD800;
        width: 108px;
        height: 42px;
        line-height: 42px;
        color: #333333;
        font-size: 14px;
        text-align: center;
        border-radius: 2px;
        cursor: pointer;
    }

    .monitorDetails_main_title .title_group {
        display: flex;
        flex-wrap: wrap;
        margin-right: -20px;
    }

    .title_group .title_item {
        padding: 14px 26px;
        color: #999999;
        font-size: 14px;
        border: 1px solid #C0C0C0;
        border-radius: 2px;
        margin: 0 20px 20px 0;
        cursor: pointer;
    }

    .title_group .title_item.active {
        border: 1px solid #FFD800;
        color: #333333;
    }

    .title_btn_group {
        display: flex;
    }

    .monitorDetails_main .tips_text {
        font-size: 14px;
        text-align: center;
        padding: 100px 0;
        color: #282828;
    }

    .tips_text .tips_text_img {
        display: inline-block;
        width: 140px;
        height: 81px;
    }

    .tips_text .tips_text_content {
        padding-top: 28px;
    }

    .monitorDetails_main .monitorDetails_group {
        padding: 0 14px 20px;
        display: flex;
        flex-wrap: wrap;
    }

    .monitorDetails_group .result_item {
        margin: 0 15px 20px 0;

    }

    .monitorDetails_group .result_item:nth-child(6n) {
        margin-right: 0;
    }

    .gray_btn, .no_data {
        width: 84px;
        height: 33px;
        line-height: 33px;
        outline: none;
        background: #f6f6f6;
        border-radius: 2px;
        border: 1px solid #efefef;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
        text-align: center;
    }

    .gray_btn:hover {
        background: #FFD800;
        border: 1px solid #FFD800;
    }

    .gray_btn.large, .no_data.large {
        width: 364px;
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        margin: 30px auto;
    }

    .obtain_evidence_tips {
        .obtain_evidence_tips_content {
            color: #121210;
            font-size: 16px;
            padding-top: 80px;
        }

        .obtain_evidence_tips_btn {
            background: #FFD800;
            color: #191919;
            font-size: 14px;
            width: 124px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            border-radius: 4px;
            margin: 64px auto 0;
            cursor: pointer;
        }
    }

    .submit-button {
        width: 230px;
        height: 42px;
        background: rgba(255, 216, 0, 1);
        border-radius: 4px;
        line-height: 42px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(78, 78, 78, 1);
        cursor: pointer;
        border: none;
        outline: none;
    }

</style>